import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import React from "react"
import ToolFieldPropertiesHeader, {
	IToolFieldPropertiesHeaderProps,
} from "./ToolFieldPropertiesHeader"

interface Props extends IToolFieldPropertiesHeaderProps {
	isContentHidden?: boolean
	children?: React.ReactNode
}

const ToolFieldPropertiesHeaderWithContent = ({
	label,
	selectedLanguage,
	titleInputValue,
	titleInputPlaceholder,
	tooltip,
	tooltipPlaceholder,
	tooltipInputHidden,
	buttonColors,
	isContentHidden,
	onChangeFormData,
	onClickLabel,
	onClickMoveUp,
	onClickMoveDown,
	onClickRemove,
	children,
}: Props) => {
	return (
		<div>
			<ToolFieldPropertiesHeader
				label={label}
				selectedLanguage={selectedLanguage}
				titleInputPlaceholder={titleInputPlaceholder}
				titleInputValue={titleInputValue}
				tooltipInputHidden={tooltipInputHidden}
				tooltipPlaceholder={tooltipPlaceholder}
				tooltip={tooltip}
				buttonColors={buttonColors}
				onChangeFormData={onChangeFormData}
				onClickLabel={onClickLabel}
				onClickMoveDown={onClickMoveDown}
				onClickMoveUp={onClickMoveUp}
				onClickRemove={onClickRemove}
				isFormHidden={isContentHidden}
			/>
			<Whitespace x="1" />
			<HyperDiv hidden={isContentHidden}>{children}</HyperDiv>
		</div>
	)
}

export default ToolFieldPropertiesHeaderWithContent
